export const GET_LINK_TEASER_BLOCK_BY_ID_M = (id, preview: boolean) => `
  query {
    linkTeaserBlock(id: "${id}", preview: ${preview}) {
        sys {id}
        heading
        text
        linksCollection {
        items {
          ... on Link {
            __typename
            linkText
            globalLinkItem
            url
            reference {
              ... on Page {
                content {
                  __typename
                }
                slug
              }
            ... on FileBlock {
            imageVaultFile
            __typename
          }
            }
          }
          ... on Faq {
            __typename
            slug
            question
          }
          ... on Page {
          __typename
            content {
              __typename
            }
            slug
            teaserLinkText
          }
        }
      }
    }
}
`;
